import React from "react";

import { isChunkLoadError, tryRecoverChunkLoadError } from "@/shared/utils/chunkLoadRecovery";

type ChunkLoadBoundaryProps = {
  children: React.ReactNode;
};

type ChunkLoadBoundaryState = {
  hasError: boolean;
  isChunkError: boolean;
};

export class ChunkLoadBoundary extends React.Component<ChunkLoadBoundaryProps, ChunkLoadBoundaryState> {
  state: ChunkLoadBoundaryState = {
    hasError: false,
    isChunkError: false,
  };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error: unknown) {
    const isChunkError = isChunkLoadError(error);

    if (isChunkError) {
      this.setState({ isChunkError: true });
    }

    if (tryRecoverChunkLoadError(error)) {
      return;
    }

    console.error("CHUNK LOAD BOUNDARY ERROR", error);
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (!this.state.hasError) {
      return this.props.children;
    }

    return (
      <div
        style={{
          display: "flex",
          minHeight: "100vh",
          alignItems: "center",
          justifyContent: "center",
          padding: "24px",
          backgroundColor: "#ffffff",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "12px",
            textAlign: "center",
            color: "#1f2937",
            fontSize: "16px",
          }}
        >
          <div>
            {this.state.isChunkError
              ? "The application was updated. Reload the page to continue."
              : "Something went wrong. Reload the page to continue."}
          </div>
          <button
            onClick={this.handleReload}
            style={{
              border: "none",
              borderRadius: "6px",
              padding: "10px 16px",
              backgroundColor: "#1273eb",
              color: "#ffffff",
              cursor: "pointer",
              fontSize: "14px",
              fontWeight: 600,
            }}
          >
            Reload page
          </button>
        </div>
      </div>
    );
  }
}
